import script from "./userOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./userOverview.vue?vue&type=script&setup=true&lang=js"

import "./userOverview.vue?vue&type=style&index=0&id=b7c9b6ba&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7c9b6ba"]])

export default __exports__